document.addEventListener("DOMContentLoaded", function () {

    let mobile = document.querySelector(".hrz-version-mobile");


    ScrollSmoother.create({
        smooth: 1.8,
        smoothTouch: 0.1,
        effects: true,
    });

    if (mobile) {
        const classesToRemove = [
            "anim-speed-m",
            "anim-speed-s",
            "anim-speed-l",
            "anim-speed-xl",
        ];

        classesToRemove.forEach((className) => {
            document.querySelectorAll(`.${className}`).forEach((el) => {
                el.classList.remove(className);
            });
        });
    }

    // ---------------------------
    //  APPEAR / DISAPPEAR ANIMATIONS
    // ---------------------------

    function animateAppearDisappear(selector, animProps) {
        gsap.utils.toArray(selector).forEach((el) => {
            gsap.fromTo(
                el,
                { opacity: 0, ...animProps.from },
                {
                    opacity: 1,
                    ...animProps.to,
                    scrollTrigger: {
                        trigger: el,
                        start: mobile ? "top 90%" : "top 80%",
                        end: mobile ? "top 40%" : "top 20%",
                        scrub: true,
                    },
                }
            );
        });
    }

    // Fade in + fade out
    animateAppearDisappear(".fade", {
        from: {},
        to: {}
    });

    // From the right
    animateAppearDisappear(".from-right", {
        from: { x: 100 },
        to: { x: 0 }
    });

    // From the left
    animateAppearDisappear(".from-left", {
        from: { x: -100 },
        to: { x: 0 }
    });

    // Gestion des modules fade
    function initScrollFadeHero() {
        const wrappers = document.querySelectorAll(".scroll-fade-wrapper");

        if (!wrappers.length) return;

        // OBLIGATOIRE : supprime les occurrence gsap pour éviter less conflits
        ScrollTrigger.getAll().forEach((st) => {
            if (st.vars && st.vars.customType === "scroll-fade-hero") {
                st.kill();
            }
        });

        wrappers.forEach((wrapper, index) => {
            const hero = wrapper.querySelector(".scroll-fade-hero");
            const content = wrapper.querySelector(".scroll-fade-hero-content");
            const heroImg = wrapper.querySelector(".scroll-fade-hero-img");

            if (!hero || !content || !heroImg) return;

            ScrollTrigger.create({
                id: `scroll-fade-hero-pin-${index}`,
                customType: "scroll-fade-hero",
                trigger: wrapper,
                start: "top top",
                endTrigger: content,
                end: "top top",
                pin: hero,
                pinSpacing: false,
                invalidateOnRefresh: true,
                //markers: true
            });

            gsap.to(heroImg, {
                yPercent: -8,
                scale: 1,
                opacity: 0,
                filter: "blur(10px)",
                ease: "none",
                scrollTrigger: {
                    id: `scroll-fade-hero-img-${index}`,
                    customType: "scroll-fade-hero",
                    trigger: wrapper,
                    start: "top top",
                    endTrigger: content,
                    end: "top top",
                    scrub: true,
                    invalidateOnRefresh: true
                }
            });
        });

        ScrollTrigger.refresh();
    }

    window.addEventListener("load", () => {
        initScrollFadeHero();
        ScrollTrigger.refresh();
    });
});
